import script from "./PopularCompetitions.vue?vue&type=script&setup=true&lang=js"
export * from "./PopularCompetitions.vue?vue&type=script&setup=true&lang=js"

import "./PopularCompetitions.vue?vue&type=style&index=0&id=1d72a62c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d72a62c"]])

export default __exports__